import Vue, { VueConstructor } from 'vue'
import ActionCableVue from 'actioncable-vue'

import { store } from '@/groupBuy/requestList/store'

const WSConnectionURL = `${/^https/.test(location.href) ? 'wss' : 'ws'}://${location.host.replace('8080', '3000')}/cable`
Vue.use(ActionCableVue, {
  debug: true,
  debugLevel: 'error',
  connectionUrl: WSConnectionURL,
  connectImmediately: true
})

import App from './App.vue'

import '../../../stylesheets/namespace/GroupBuy.css'

const mountEl = document.querySelector('#group-buy-show-request') as HTMLElement

const install = (mountEl: HTMLElement, component: VueConstructor<Vue>) => {
  if (!mountEl) return false

  new Vue({
    store,
    render: h => h(component, {
      props: {}
    })
  }).$mount(mountEl)
}

install(mountEl, App)
